import { Action, Dispatch } from 'redux';
import { thunkGetStateFunc } from '../../Redux/store.provider';
import { FormBaseStore } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { saveOrder } from '../../services/formModel.service';
import { ResponseError } from 'sos-common/js/utils/ResponseError';
import { dialogueError } from '../../Redux/Actions/errors.actions';
import {
  getErrorBodyVipSPSessionTimeout,
  getErrorBodyJwtTokenTimeout,
  getErrorBodyApiErrorOnSave,
  getErrorBodyApiErrorOnSaveClose,
} from 'sos-eservice-common/js/config/dialogueErrorBodies';

export const ESERVICE_MENU_DELETE = 'ESERVICE_MENU_DELETE';
export const ESERVICE_MENU_SAVE = 'ESERVICE_MENU_SAVE';
export const ESERVICE_MENU_SAVE_CLOSE = 'ESERVICE_MENU_SAVE_CLOSE';
export const ESERVICE_MENU_AFTER_SAVE_CLOSE = 'ESERVICE_MENU_AFTER_SAVE_CLOSE';

export type deleteAction = Action<typeof ESERVICE_MENU_DELETE>;

export function deleteAction() {
  return {
    type: ESERVICE_MENU_DELETE,
  };
}
export type saveOrderAction = Action<typeof ESERVICE_MENU_SAVE>;

export function saveAction() {
  return {
    type: ESERVICE_MENU_SAVE,
  };
}

export function saveOrderAction() {
  return function (dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    const { globals } = getState();
    return saveOrder(getState().formModel, globals.orderId).then((result) => {
      if (result instanceof ResponseError) {
        const error = result as ResponseError;
        if (error.body.detailCode) {
          // SESSION ERROR
          switch (error.body.detailCode) {
            case '401.1':
              // VIP (SP) SESSION TIMED OUT
              dispatch(dialogueError(getErrorBodyVipSPSessionTimeout(error.body.redirectUri)));
              break;
            case '401.2':
              // JWT TOKEN TIMED OUT
              dispatch(dialogueError(getErrorBodyJwtTokenTimeout(error.body.redirectUri)));
              break;
          }
        } else {
          switch (error.statusCode) {
            case 400:
              // API error
              dispatch(dialogueError(getErrorBodyApiErrorOnSave(globals.homePageUrl, error.body.errorMessage)));
              break;
            default:
              dispatch(dialogueError(getErrorBodyApiErrorOnSave(globals.homePageUrl, error.body.errorMessage)));
          }
        }
      } else {
        // This will currently only trigger the green bar via globals.reducer.ts
        dispatch(saveAction());
      }
    });
  };
}

export type saveCloseAction = Action<typeof ESERVICE_MENU_SAVE_CLOSE>;
export function saveCloseAction() {
  return function (dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    const { globals } = getState();
    return saveOrder(getState().formModel, globals.orderId).then((result) => {
      if (result instanceof ResponseError) {
        const error = result as ResponseError;
        if (error.body.detailCode) {
          switch (error.body.detailCode) {
            case '401.1':
              // VIP (SP) SESSION TIMED OUT
              dispatch(dialogueError(getErrorBodyVipSPSessionTimeout(error.body.redirectUri)));
              break;
            case '401.2':
              // JWT TOKEN TIMED OUT
              dispatch(dialogueError(getErrorBodyJwtTokenTimeout(error.body.redirectUri)));
              break;
          }
        } else {
          switch (error.statusCode) {
            case 400:
              // API error
              dispatch(dialogueError(getErrorBodyApiErrorOnSaveClose(globals.homePageUrl, error.body.errorMessage)));
              break;
            default:
              dispatch(dialogueError(getErrorBodyApiErrorOnSaveClose(globals.homePageUrl, error.body.errorMessage)));
          }
        }
      } else {
        // This will currently only trigger the green bar via globals.reducer.ts
        dispatch(saveAction());
        // Redirect to "Min sida"
        window.location.href = globals.homePageUrl;
      }
    });
  };
}
/*
export function saveCloseAction() {
  return {
    type: ESERVICE_MENU_SAVE_CLOSE
  };
}
*/
export type afterSaveCloseAction = Action<typeof ESERVICE_MENU_AFTER_SAVE_CLOSE>;

export function afterSaveCloseAction() {
  return {
    type: ESERVICE_MENU_AFTER_SAVE_CLOSE,
  };
}

export type eserviceMenuActions = deleteAction | saveOrderAction | saveCloseAction | afterSaveCloseAction;
